import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const purchases = [{
  name: 'Carlos Medina',
  location: 'Rosario, Santa Fe'
}, {
  name: 'Jorge Ramírez',
  location: 'Mendoza, Argentina'
}, {
  name: 'Luis Castillo',
  location: 'Córdoba, Argentina'
}, {
  name: 'Roberto Mendoza',
  location: 'La Plata, Buenos Aires'
}, {
  name: 'Diego Vargas',
  location: 'Neuquén, Argentina'
}, {
  name: 'Fernando Acosta',
  location: 'Salta, Argentina'
}, {
  name: 'Mario Salazar',
  location: 'Tucumán, Argentina'
}, {
  name: 'Eduardo Rojas',
  location: 'San Juan, Argentina'
}, {
  name: 'Andrés Morales',
  location: 'Paraná, Entre Ríos'
}, {
  name: 'Ricardo Paredes',
  location: 'Posadas, Misiones'
}, {
  name: 'Javier Quintero',
  location: 'Bahía Blanca, Buenos Aires'
}, {
  name: 'Sergio Domínguez',
  location: 'Santiago del Estero, Argentina'
}, {
  name: 'Pablo Ortiz',
  location: 'Resistencia, Chaco'
}, {
  name: 'Alejandro Núñez',
  location: 'San Luis, Argentina'
}, {
  name: 'Gustavo Ríos',
  location: 'Mar del Plata, Buenos Aires'
}, {
  name: 'Hugo Barrera',
  location: 'Tandil, Buenos Aires'
}, {
  name: 'Néstor Mansilla',
  location: 'Santa Rosa, La Pampa'
}, {
  name: 'Martín Ferreyra',
  location: 'Concordia, Entre Ríos'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 6000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 12000) + 12000;
      setTimeout(showNextPopup, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[260px] md:max-w-[290px]" data-id="element-275">
      <div className="bg-zinc-900 rounded-xl shadow-2xl border-[3px] border-brand-green p-3 flex items-start gap-2.5 relative glow-green" data-id="element-276">
        <button onClick={() => setIsVisible(false)} aria-label="Cerrar" className="absolute top-1.5 right-1.5 text-zinc-500 hover:text-white transition-colors" data-id="element-277">
          <X className="w-3.5 h-3.5" data-id="element-278" />
        </button>

        <div className="bg-brand-green/20 p-1.5 rounded-full shrink-0 border-2 border-brand-green mt-1" data-id="element-279">
          <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-brand-greenLight" data-id="element-280" />
        </div>

        <div className="pr-3" data-id="element-281">
          <p className="text-xs text-white font-semibold leading-tight mb-0.5" data-id="element-282">
            <span className="font-bold text-brand-greenLight" data-id="element-283">
              {currentPurchase.name}
            </span>{' '}
            <span className="text-zinc-400" data-id="element-284">de</span> {currentPurchase.location}
          </p>
          <p className="text-[10px] text-zinc-300 leading-tight mt-1" data-id="element-285">
            Acaba de comprar el Sistema Pro Corrales 🐄
          </p>
          <p className="text-[9px] text-brand-greenLight font-bold mt-1 uppercase tracking-wider" data-id="element-286">
            ● Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-287">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}